/* ===========================================================
   ROOTSLANE FEATURED PRODUCTS
=========================================================== */

document.addEventListener('DOMContentLoaded', function () {

  const tabs = document.querySelectorAll('.rootslane-tab');
  const panels = document.querySelectorAll('.rootslane-products');
  const exploreItems = document.querySelectorAll('.rl-explore-item');

  if (!tabs.length || !panels.length) return;

  /*==========================================
  Update Explore Categories
==========================================*/
/*==========================================
  Update Explore Categories
==========================================*/

function updateExplore(tabId) {

  exploreItems.forEach(function (item) {

    if (item.dataset.tab === tabId) {

      item.classList.add('is-hidden');

    } else {

      item.classList.remove('is-hidden');

    }

  });

}

  tabs.forEach(function (tab) {

   tab.addEventListener('click', function () {

  const tabId = this.dataset.tab;
  
  // Remove active state from all tabs
  tabs.forEach(function (item) {
    item.classList.remove('active');
    item.setAttribute('aria-selected', 'false');
  });

  // Hide all product panels
  panels.forEach(function (panel) {
    panel.classList.remove('active');
  });

  // Activate clicked tab
  this.classList.add('active');
  this.setAttribute('aria-selected', 'true');
  updateExplore(tabId);

  // Show matching products
 const activePanel = document.querySelector(
    '.rootslane-products[data-content="' + tabId + '"]'
);

if (activePanel) {
    activePanel.classList.add('active');

    // Scroll so the first product starts below the sticky tabs
    const top =
        activePanel.getBoundingClientRect().top +
        window.pageYOffset -
        tabsWrapper.offsetHeight;

    window.scrollTo({
        top,
        behavior: 'smooth'
    });


 
}
});

  });

  /*==========================================
  Explore Category Click
==========================================*/

exploreItems.forEach(function (item) {

  item.addEventListener('click', function () {

    const targetTab = document.querySelector(
      '.rootslane-tab[data-tab="' + this.dataset.tab + '"]'
    );

    if (targetTab) {

      targetTab.click();

    }

  });

});

/*==========================================
  Initial Explore State
==========================================*/

const activeTab = document.querySelector('.rootslane-tab.active');

if (activeTab) {

  updateExplore(activeTab.dataset.tab);

}

 /*==========================================
  Sticky Tabs V3
==========================================*/

const section = document.getElementById('rootslane-featured-products');
const tabsWrapper = document.querySelector('.rootslane-tabs-wrapper');
const spacer = document.querySelector('.rootslane-tabs-spacer');

if (section && tabsWrapper && spacer) {

    let sticky = false;
    


    window.addEventListener('scroll', function () {

       

        const sectionTop = section.getBoundingClientRect().top;

        if (!sticky && sectionTop <= 0) {

            spacer.style.height = tabsWrapper.offsetHeight + 'px';

            spacer.classList.add('active');
tabsWrapper.classList.add('rl-fixed');

            sticky = true;

        }

        if (sticky && sectionTop > 0) {

            spacer.classList.remove('active');

           tabsWrapper.classList.remove('rl-fixed');

            sticky = false;

        }

    });

}
});